import React from "react";
import Brands from "src/components/Brands";
import Locations from "src/components/Locations";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/components/ui/tabs";

const Settings = () => {
  return (
    <div>
      <div className="flex items-center justify-between mb-[3rem]">
        <p className="text-[2.5rem] font-medium text-defaultPrimary">
          Settings
        </p>
      </div>
      <>
        <Tabs defaultValue="locations" className="">
          <TabsList>
            <TabsTrigger value="locations">Warehouse</TabsTrigger>
            <TabsTrigger value="brands">Brands</TabsTrigger>
          </TabsList>
          <TabsContent value="locations">
            <Locations />
          </TabsContent>
          <TabsContent value="brands">
            <Brands />
          </TabsContent>
        </Tabs>
      </>
    </div>
  );
};

export default Settings;
